import { TextField, InputAdornment, Grid, Button } from "@mui/material";
import * as React from "react";
import { ChangeEvent, useEffect, useState } from "react";
import { FormGridItem } from "../../common/form-field";

interface Props {
    bon: Bon,
    onSubmit: onSubmit
    needToBeSign: boolean
    isProcedurePending: boolean
    isClient?: boolean
}

interface Bon {
    client: { name: string },
    article: { name: string, famille?: string }
    chauffeur: { name: string }
    chantier: { adresse: string, name: string }
    consignes: { chauffeur: string, evenement: string }
    commande: { quantite: number, unite: string, fraisAutoroute: number }
    procedure?: {
        immatriculation: string,
        client?: string,
        fournisseur?: string,
        observations?: { fournisseur?: string, client?: string }
        fournisseurConfirmation: boolean
    }
    
}
 
type onSubmit = (immatriculation: string, fraisAutoroute?: number, observation?: string,) => void;

function ValidateBeforeSigningForm({ bon, onSubmit, needToBeSign, isProcedurePending, isClient }: Props) {
    const [immatriculation, setImmatriculation] = useState<string>('');
    const [fraisAutoroute, setFraisAutoroute] = useState<number>(0);
 
    const [observation, setObservation] = useState<string>('');

    const [adresse, setAdresse] = useState<string>(bon?.chantier?.adresse || '');

    const [isLoading,setIsLoading] = useState(false);

    useEffect(() => {
        if (bon?.procedure) setImmatriculation(bon.procedure.immatriculation);
        if (bon?.commande?.fraisAutoroute) setFraisAutoroute(bon.commande.fraisAutoroute);
        if(isClient && bon?.procedure?.observations?.client) {
            setObservation(bon?.procedure?.observations?.client);
        }
        if(!isClient && bon?.procedure?.observations?.fournisseur) {
            setObservation(bon?.procedure?.observations?.fournisseur);
        }
        //if (bon?.procedure?.observations?.fournisseur) setObservation(bon?.procedure?.observations?.fournisseur);
        if (bon?.chantier?.adresse) setAdresse(bon?.chantier?.adresse);
    }, [bon, isClient])

    const addObservation = (event: ChangeEvent<HTMLInputElement>) => { setObservation(event.target.value); };
    const addImmatriculation = (event: ChangeEvent<HTMLInputElement>) => { setImmatriculation(event.target.value); };
    const addFraisAutoroute = (event: ChangeEvent<HTMLInputElement>) => { setFraisAutoroute(+event.target.value); };

    const getBonQuantityOrEmptyString = (): string => bon
        ? `${bon?.commande.quantite} ${bon?.commande.unite}`
        : '';

    // const isProcedurePending = () => !!bon?.procedure?.client && !!bon?.procedure?.fournisseur;

    const onClickConfirm = () => {
        onSubmit(immatriculation, fraisAutoroute, observation);
        setIsLoading(true);
    }

    const bonConsigneChauffeur = bon?.consignes.chauffeur ? bon?.consignes.chauffeur : '';
    return <>
        <FormGridItem>
            <TextField fullWidth variant="standard" disabled value={`${bon?.client.name}`} label="Entreprise" />
      
            <TextField fullWidth variant="standard" disabled value={`${bon?.article.name}`} label="Article" />
        </FormGridItem>
        <FormGridItem>
            <TextField
                fullWidth
                variant="standard"
                disabled
                value={`${bon?.chauffeur.name}`}
                label="Chauffeur"
            />
        
            <TextField
                fullWidth
                variant="standard"
                disabled
                value={adresse}
                defaultValue={adresse}
                label="Adresse "
            />
        </FormGridItem>
        <FormGridItem>
            <TextField
                fullWidth
                variant="standard"
                disabled
                value={getBonQuantityOrEmptyString()}
                label="Unité"
            />
            <TextField
                fullWidth
                variant="standard"
                disabled
                value={`${bon?.chantier.name}`}
                label="Chantier"
            />
        </FormGridItem>
        <FormGridItem>
            <TextField
                fullWidth
                variant="standard"
                disabled
                multiline
                rows={3}
                value={bonConsigneChauffeur}
                label="Consignes"
            />
         
            <TextField
                fullWidth
                variant="standard"
                disabled
                multiline
                rows={3}
                value={`${bon?.consignes?.evenement ?? ''}`}
                label="Evenements"
            />
        </FormGridItem>
        <FormGridItem>
            {(needToBeSign && !isClient) ? (
                <TextField
                    fullWidth
                    variant="outlined"
                    onChange={addImmatriculation}
                    value={immatriculation}
                    defaultValue={immatriculation}
                    label="N° Immatriculation"
                    disabled={isProcedurePending}
                />
            ) : (
                <TextField fullWidth variant="outlined" disabled value={immatriculation} label="N° Immatriculation" />
            )}
        </FormGridItem>
        <FormGridItem>
        {(needToBeSign && !isClient) ? (
            <TextField
                fullWidth
                variant="outlined"
                onChange={addFraisAutoroute}
                label="Frais d'autoroute"
                value={fraisAutoroute}
                defaultValue={fraisAutoroute}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                    type: 'number',
                    endAdornment: <InputAdornment position="end">€</InputAdornment>,
                }}
                disabled={isProcedurePending}
            />
        ) : (
            <TextField fullWidth variant="outlined" disabled value={fraisAutoroute} label="Frais d'autoroute"   InputProps={{
                type: 'number',
                endAdornment: <InputAdornment position="end">€</InputAdornment>,
            }} />
        )}
        </FormGridItem>
        <FormGridItem>
        {isClient ? (
             <TextField
             fullWidth
             variant="standard"
             disabled
             multiline
             rows={3}
             value={`${bon?.procedure?.observations?.fournisseur ?? ''}`}
             
             label="Observations du chauffeur"
         />
        ) : ''}
           
        
        <TextField fullWidth variant="outlined"
                onChange={addObservation}
                label="Vos observations"
                multiline rows={3}
                value={observation}
                defaultValue={observation}
                disabled={isProcedurePending && !isClient} />
            
        </FormGridItem>

        <Grid item display="flex" justifyContent="flex-end" sx={{ my: 2 }} xs={12} gap={3}>
            {/* <Button variant="contained" color="warning" disabled={signed}>
      Modifier
    </Button> */}
    {!isLoading && needToBeSign &&
     <Button
        onClick={onClickConfirm}
        variant="contained"
        color="primary"
        disabled={ (bon.article.famille === "Transport" && !immatriculation) || (!bon?.procedure?.fournisseurConfirmation && isClient) }
     >
     {!isProcedurePending ? "Confirmer et " : ""}signer
 </Button>
    }
     {isLoading && 
     <Button variant="contained" color="primary" >
     Génération en cours ...
 </Button>
 }
           
        </Grid>
        {/* </Grid > */}
    </>
}

export default ValidateBeforeSigningForm;